// import React, { useState, useEffect, useRef } from "react";
// import "./TestimonialsSection.css";
// import api from "../../utils/api";
// import { getImageSrc } from "../../utils/getImageSrc";

// const StarRating = ({ rating }) => (
//   <div className="ts-stars">
//     {[1, 2, 3, 4, 5].map((s) => (
//       <span key={s} className={s <= rating ? "ts-star filled" : "ts-star"}>★</span>
//     ))}
//   </div>
// );

// const ReviewCard = ({ review }) => (
//   <div className={`ts-card${review.isTop ? " ts-card--top" : ""}`}>
//     {review.isTop && (
//       <div className="ts-top-badge">
//         🏆 Top {review.reviewedType === "institution" ? "Center" : "Tutor"}
//       </div>
//     )}
//     <StarRating rating={review.rating} />
//     <blockquote className="ts-quote">
//       "{review.comment || review.quote}"
//     </blockquote>
//     <div className="ts-reviewer">
//       <img src={review.avatar} alt={review.name} className="ts-avatar" />
//       <div className="ts-reviewer-info">
//         <strong className="ts-reviewer-name">{review.name}</strong>
//         <span className="ts-reviewer-meta">
//           <span className={`ts-role-badge ts-role-badge--${review.role?.toLowerCase()}`}>
//             {review.role}
//           </span>
//           {review.location && (
//             <span className="ts-location">· {review.location}</span>
//           )}
//         </span>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonCard = () => (
//   <div className="ts-card ts-card--skeleton">
//     <div className="ts-skel ts-skel--stars" />
//     <div className="ts-skel ts-skel--line" />
//     <div className="ts-skel ts-skel--line short" />
//     <div className="ts-skel ts-skel--line shorter" />
//     <div className="ts-skel ts-skel--avatar-row">
//       <div className="ts-skel ts-skel--avatar" />
//       <div className="ts-skel ts-skel--name" />
//     </div>
//   </div>
// );

// const TestimonialsSection = () => {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Pause marquee on hover
//   const track1Ref = useRef(null);
//   const track2Ref = useRef(null);

//   useEffect(() => {
//     const fetchTestimonials = async () => {
//       try {
//         setLoading(true);
//         const res = await api.get("/reviews/public?limit=28");
//         const formatted = (res.data.reviews || []).map((r, index) => {
//           const isAcademy = r.reviewed?.role === "institution";
//           const rating = r.overallRating || 0;
//           return {
//             id: r._id || index,
//             name: isAcademy
//               ? r.reviewed?.academyName || "Training Center"
//               : `${r.reviewed?.firstName || ""} ${r.reviewed?.lastName || ""}`.trim(),
//             location: r.reviewed?.location?.address || "Nigeria",
//             role: isAcademy ? "Center" : "Tutor",
//             avatar: getImageSrc(r.reviewed?.picture),
//             quote: r.comment,
//             comment: r.comment,
//             rating: Math.round(rating || 5),
//             isTop: rating >= 4 && (r.comment?.length || 0) > 30,
//             reviewedType: r.reviewedType,
//           };
//         });
//         setReviews(formatted);
//       } catch (err) {
//         console.error("Testimonials fetch failed:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchTestimonials();
//   }, []);

//   const handleMouseEnter = () => {
//     [track1Ref, track2Ref].forEach((ref) => {
//       if (ref.current) ref.current.style.animationPlayState = "paused";
//     });
//   };

//   const handleMouseLeave = () => {
//     [track1Ref, track2Ref].forEach((ref) => {
//       if (ref.current) ref.current.style.animationPlayState = "running";
//     });
//   };

//   // Split reviews into two rows; duplicate for seamless loop
//   const mid = Math.ceil(reviews.length / 2);
//   const row1 = reviews.slice(0, mid);
//   const row2 = reviews.slice(mid);

//   return (
//     <section className="ts-section">
//       {/* Decorative gradient orbs */}
//       <div className="ts-orb ts-orb--left"  aria-hidden="true" />
//       <div className="ts-orb ts-orb--right" aria-hidden="true" />

//       <div className="ts-header">
//         <p className="ts-eyebrow">Testimonials</p>
//         <h2 className="ts-title">What Our Users Say</h2>
//         <p className="ts-subtitle">
//           Trusted by students, tutors, and training centers across Nigeria.
//         </p>
//       </div>

//       {loading ? (
//         <div className="ts-skeleton-grid">
//           {[...Array(4)].map((_, i) => <SkeletonCard key={i} />)}
//         </div>
//       ) : reviews.length === 0 ? (
//         <p className="ts-empty">No testimonials yet — be the first to leave a review!</p>
//       ) : (
//         <div
//           className="ts-marquee-wrapper"
//           onMouseEnter={handleMouseEnter}
//           onMouseLeave={handleMouseLeave}
//         >
//           {/* Fade edges */}
//           <div className="ts-fade ts-fade--left"  aria-hidden="true" />
//           <div className="ts-fade ts-fade--right" aria-hidden="true" />

//           {/* Row 1 — scrolls left */}
//           <div className="ts-marquee-row">
//             <div className="ts-track ts-track--ltr" ref={track1Ref}>
//               {[...row1, ...row1].map((r, i) => (
//                 <ReviewCard key={`r1-${r.id}-${i}`} review={r} />
//               ))}
//             </div>
//           </div>

//           {/* Row 2 — scrolls right (reverse) */}
//           {row2.length > 0 && (
//             <div className="ts-marquee-row">
//               <div className="ts-track ts-track--rtl" ref={track2Ref}>
//                 {[...row2, ...row2].map((r, i) => (
//                   <ReviewCard key={`r2-${r.id}-${i}`} review={r} />
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </section>
//   );
// };

// export default TestimonialsSection;


import React, { useRef } from "react";
import "./TestimonialsSection.css";
import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";
import { getImageSrc } from "../../utils/getImageSrc";

// ── fetcher ────────────────────────────────────────────────────────────────
const fetchTestimonials = () =>
  api.get("/reviews/public?limit=28").then((r) => r.data);

// ── sub-components (unchanged) ─────────────────────────────────────────────
const StarRating = ({ rating }) => (
  <div className="ts-stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <span key={s} className={s <= rating ? "ts-star filled" : "ts-star"}>
        ★
      </span>
    ))}
  </div>
);

const ReviewCard = ({ review }) => (
  <div className={`ts-card${review.isTop ? " ts-card--top" : ""}`}>
    {review.isTop && (
      <div className="ts-top-badge">
        🏆 Top {review.reviewedType === "institution" ? "Training Center" : "Tutor"}
      </div>
    )}
    <StarRating rating={review.rating} />
    <blockquote className="ts-quote">
      "{review.comment || review.quote}"
    </blockquote>
    <div className="ts-reviewer">
      {/* Reviewer avatars are below-the-fold marquee items → always lazy */}
      <img
        src={review.avatar}
        alt={review.name}
        className="ts-avatar"
        loading="lazy"
        decoding="async"
        width={40}
        height={40}
      />
      <div className="ts-reviewer-info">
        <strong className="ts-reviewer-name">{review.name}</strong>
        <span className="ts-reviewer-meta">
          <span
            className={`ts-role-badge ts-role-badge--${review.role?.toLowerCase()}`}
          >
            {review.role}
          </span>
          {review.location && (
            <span className="ts-location">· {review.location}</span>
          )}
        </span>
      </div>
    </div>
  </div>
);

const SkeletonCard = () => (
  <div className="ts-card ts-card--skeleton">
    <div className="ts-skel ts-skel--stars" />
    <div className="ts-skel ts-skel--line" />
    <div className="ts-skel ts-skel--line short" />
    <div className="ts-skel ts-skel--line shorter" />
    <div className="ts-skel ts-skel--avatar-row">
      <div className="ts-skel ts-skel--avatar" />
      <div className="ts-skel ts-skel--name" />
    </div>
  </div>
);

// ── main component ─────────────────────────────────────────────────────────
const TestimonialsSection = () => {
  const track1Ref = useRef(null);
  const track2Ref = useRef(null);

  const { data: rawData, isLoading } = useQuery({
    queryKey: ["testimonials"],
    queryFn: fetchTestimonials,
    staleTime: 5 * 60 * 1000,   // reuse cached data for 5 min
    gcTime: 10 * 60 * 1000,
    select: (data) =>
      // transform inside `select` so the raw response stays cached separately
      (data.reviews || []).map((r, index) => {
        const isAcademy = r.reviewed?.role === "institution";
        const rating = r.overallRating || 0;
        return {
          id: r._id || index,
          name: isAcademy
            ? r.reviewed?.academyName || "Training Center"
            : `${r.reviewed?.firstName || ""} ${r.reviewed?.lastName || ""}`.trim(),
          location: r.reviewed?.location?.address || "Nigeria",
          role: isAcademy ? "Training Center" : "Tutor",
          avatar: getImageSrc(r.reviewed?.picture),
          quote: r.comment,
          comment: r.comment,
          rating: Math.round(rating || 5),
          isTop: rating >= 4 && (r.comment?.length || 0) > 30,
          reviewedType: r.reviewedType,
        };
      }),
  });

  const reviews = rawData || [];

  const handleMouseEnter = () => {
    [track1Ref, track2Ref].forEach((ref) => {
      if (ref.current) ref.current.style.animationPlayState = "paused";
    });
  };

  const handleMouseLeave = () => {
    [track1Ref, track2Ref].forEach((ref) => {
      if (ref.current) ref.current.style.animationPlayState = "running";
    });
  };

  const mid = Math.ceil(reviews.length / 2);
  const row1 = reviews.slice(0, mid);
  const row2 = reviews.slice(mid);

  return (
    <section className="ts-section">
      <div className="ts-orb ts-orb--left" aria-hidden="true" />
      <div className="ts-orb ts-orb--right" aria-hidden="true" />

      <div className="ts-header">
        <p className="ts-eyebrow">Testimonials</p>
        <h2 className="ts-title">What Our Users Say</h2>
        <p className="ts-subtitle">
          Trusted by students, tutors, and training centers across Nigeria.
        </p>
      </div>

      {isLoading ? (
        <div className="ts-skeleton-grid">
          {[...Array(4)].map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      ) : reviews.length === 0 ? (
        <p className="ts-empty">
          No testimonials yet — be the first to leave a review!
        </p>
      ) : (
        <div
          className="ts-marquee-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="ts-fade ts-fade--left" aria-hidden="true" />
          <div className="ts-fade ts-fade--right" aria-hidden="true" />

          <div className="ts-marquee-row">
            <div className="ts-track ts-track--ltr" ref={track1Ref}>
              {[...row1, ...row1].map((r, i) => (
                <ReviewCard key={`r1-${r.id}-${i}`} review={r} />
              ))}
            </div>
          </div>

          {row2.length > 0 && (
            <div className="ts-marquee-row">
              <div className="ts-track ts-track--rtl" ref={track2Ref}>
                {[...row2, ...row2].map((r, i) => (
                  <ReviewCard key={`r2-${r.id}-${i}`} review={r} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default TestimonialsSection;
